<template>
  <div class="list">
    <NavBar msg="交易规则"></NavBar>
    <div class="list-main" style="white-space: pre-wrap;" v-if="isGn" v-html="tradingRules"></div>
    <div class="list-main" v-else>
      <p>
        1.
        开通模拟交易后，每位用户将获得一定初始资金的模拟账户，用于模拟实盘交易。资金量由平台统一确定，具体可进入模拟账户查看。
      </p>
      <p>
        2.
        重置账户后，模拟账户本金重置为初始模拟资金，且账户所有的盈利和亏损都将清零；
      </p>
      <p>
        3. 交易时间：交易日上午9：30-11：30,下午13：00-15：00
        系统自动撤单：交易日15:00前委托单未成交部分，将于15:00后被自动撤单
        委托时间：接受24小时委托，交易日15:00前的委托单于当日交易时间撮合
      </p>
      <p>
        4. 交易种类：支持上交所和深交所上市的A股股票，不支持科创板盘后交易。
      </p>
      <p>
        5.
        成交价格：按照交易所公布的最新成交价撮合，模拟交易无法买进涨停的股票，也无法卖出跌停的股票；
      </p>
      <p>6. 股票买卖数量需为100的整数倍；</p>
      <p>7. 交易手续费：买入卖出双向收取佣金万4，卖出收取印花税千1</p>
      <p>
        8.
        友情提醒：模拟盘是为大家提供股票交易学习和练习的平台，无法考虑真实市场的所有情形，股市有风险，入市需谨慎。
      </p>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import tradingAdd from '@/api/tradingAdd'
export default {
  components: {
    NavBar,
  },
  data() {
    return {
      tradingRules: '',
      isGn: false
    };
  },
  created() {
    if (sessionStorage.getItem("isGn")) {
      this.isGn = true
      this.gettradingRules();
    }

  },
  methods: {
    gettradingRules() {
      tradingAdd.tradingRules({ accountId:   localStorage.getItem("userId") }).then((data) => {
      
        this.tradingRules = data.data.tradingRules
      })
    }
  }
};
</script>

<style lang="less" scoped>
.list {
  font-size: 0.28rem;
  line-height: 0.42rem;
  background: #fff;
  height: 100%;
  overflow: hidden;

  .list-main {
    border-top: 1px solid #f8f8f8;
    padding: 0.32rem;
    margin-top: 0.88rem;
  }

  p {
    margin-top: 0.1rem;
  }
}
</style>